import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { get } from "lodash";
import { Typography } from "antd";
import { CustomerProps } from "../../ShowCustomer";
import { useSmartAssistStore } from "../store";
import { NAV_ITEMS } from "../helper";
import { ActiveEngagement } from "../../ShowEngagement";
const { Title, Text } = Typography;

export const SmartAssistPhase1 = () => {
  const { customer } = useContext(CustomerProps);
  const { activeEngagement } = useContext(ActiveEngagement);

  const { setCurrentSaPhase, selectedIssue, setSelectedIssue, setResponses, saCustomerIssues, saSubmitIssue, saPastResolution, saPastResponse, resetSaEvaluatedResolution, setIsCxUsedProductBefore, setIsSubmitDisabled } = useSmartAssistStore();

  const onClickContinue = async (issue) => {
    setSelectedIssue(issue);
    setResponses({});
    if (issue.label === NAV_ITEMS.HOW_TO_USE) {
      setCurrentSaPhase(NAV_ITEMS.HOW_TO_USE)
      // default true
      setIsCxUsedProductBefore(true);
    } else {
      resetSaEvaluatedResolution();
      const questionsMap = await saSubmitIssue(customer.id, issue.issue_key, activeEngagement);
      saPastResponse(customer.id, { question_ids: Object.keys(questionsMap || {})?.map(Number) });
      saPastResolution(customer.id, issue.issue_key);
      setCurrentSaPhase(NAV_ITEMS.SUMMARY);
    }
    setIsSubmitDisabled(true);
  };

  return (
    <>
      <Title level={3} style={{ color: "#1890ff" }}>
        Hi, {get(customer, ['assignment', 'first_name'])} Welcome to Smart Assist <br />
        Start by selecting a Customer query.
      </Title>

      <div style={{ marginTop: "20px" }}>
        <Text strong>Select Customer's issue:</Text>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
          {saCustomerIssues?.map((issue) => (
            <Button
              key={issue.id}
              type={selectedIssue.label === issue.label ? "primary" : "default"}
              disabled={!issue.is_active}
              onClick={() => onClickContinue(issue)}
              className="rounded-4 px-4 py-2"
              style={{ fontSize: "12px" }}
            >
              {issue.label}
            </Button>
          ))}
        </div>
      </div>

    </>
  )
}
export default SmartAssistPhase1;
